import combineReducers from 'redux-immutable-combine-reducers';

import features from './features/reducer';
import organisation from './organisation/reducer';

export default combineReducers({
  features,
  organisation,
});



// WEBPACK FOOTER //
// ./src/store/settings/index.js